import React from "react";
import { Modal } from "react-bootstrap";
import "../../style/modal.css";

export default function TruAgentModal({ show, onHide }) {
      return (
          <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details truagent-modal" show={show} centered>
              <Modal.Header className="justify-content-between">
                  <Modal.Title>Tru<b>Agent</b><span>™</span></Modal.Title>
                  <button type="button" onClick={onHide} className="close-icon-style">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                      </svg>
                  </button>
              </Modal.Header>
              <Modal.Body>
                  <span className="modal-desc">Agents with the exclusive TruAgent™ badge have demonstrated a consistent track record of offering quality, up-to-date listings. They are also known for their responsiveness, helping to ensure a smooth and hassle-free property search experience.</span>
              </Modal.Body>
          </Modal>
      );
  }
  
